module.exports = __webpack_public_path__ + "static/img/hover-iocn6.5b123b0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/add_icon/hover-iocn6.svg
// module id = xQFE
// module chunks = 1